export const getFoundingDocumentImageRf = (foundingDocument: string) => {
  return {
    label: {
      eng: `${
        foundingDocument === '5'
          ? 'Scanned copy of the Minutes of Appointment*'
          : foundingDocument === '4'
          ? 'Scanned copy of the Proxy*' : 'Scanned copy of the Appointment Order*'
      }`,
      rus: `${
        foundingDocument === '5'
          ? 'Скан-копия протокола о назначении*'
          : foundingDocument === '4'
          ? 'Скан-копия доверенности*' : 'Скан-копия приказа о назначении*'
      }`,
      kz: `${
        foundingDocument === '5'
          ? 'Тағайындау туралы хаттаманың сканерленген көшірмесі*'
          : foundingDocument === '4'
          ? 'Сенімхаттың сканерленген көшірмесі*' : 'Тағайындау туралы бұйрықтың сканерленген көшірмесі*'
      }`,
    },
    placeholder: {
      eng: 'Select or drag a file',
      rus: 'Выберите или перетащите файл',
      kz: 'Файлды таңдаңыз немесе сүйреңіз',
    },
    invalidText: {
      eng: 'Upload a photo',
      rus: 'Загрузите фото',
      kz: 'фотосуретін жүктеңіз',
    },
  }
}